import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { definitions } from '@luxuryescapes/contract-svc-promo';

import { toPromoBrand } from '~/consts/promoBrand';

import { Voucher, listVouchers } from '~/services/PromoService';

export const voucherQueryKeys = {
  all: ['vouchers'] as const,
  lists: () => [...voucherQueryKeys.all, 'list'] as const,
  byIds: (ids: Array<string>) => [...voucherQueryKeys.lists(), 'by-ids', ids] as const,
};

type Params = {
  voucherIds: Array<string>;
  brand: string;
  enabled?: boolean;
};

export function useGetVouchersByIds({ voucherIds, brand, enabled = true }: Params) {
  const normalizedIds = useMemo(() => {
    const ids = voucherIds.filter(Boolean);
    return Array.from(new Set(ids)).sort();
  }, [voucherIds]);

  const promoBrand: definitions['Promo Brands'] = toPromoBrand(brand) ?? 'luxuryescapes';

  const query = useQuery({
    queryKey: [...voucherQueryKeys.byIds(normalizedIds), promoBrand],
    queryFn: async () => {
      const response = await listVouchers({
        voucher_ids: normalizedIds,
        brand: promoBrand,
        limit: normalizedIds.length,
      });
      const vouchers = response.result?.vouchers ?? [];
      return new Map<string, Voucher>(vouchers.map((v) => [v.voucherId, v]));
    },
    enabled: enabled && normalizedIds.length > 0,
  });

  return query;
}
